export default __webpack_public_path__ + "static/media/mamut_background_s1.11a64c79.jpg";